import "./App.css";
import { Provider } from "react-redux";
import { legacy_createStore as createStore } from "redux";
import reducers from "./redux/";
import Root from "./Root";

function App() {
  const store = createStore(reducers);
  return (
    <Provider store={store}>
      <div>
        <Root />
      </div>
    </Provider>
  );
}

export default App;
